import React, { useState } from "react";
import GoogleMapReact from "google-map-react";
import { GOOGLE_MAPS_KEY } from "../../constants/map";
import { MAP_STYLES } from "../../constants/colors";
import Marker from "../markers/marker";

const InfoWindow = ({ text }) => <div>{text}</div>;

const containerStyle = {
  maxWidth: "1206px",
  height: "687px",
  margin: "0 auto",
  marginBottom: "100px",
};

const center = {
  lat: 36.4,
  lng: -12.0,
};

const markers = [
  {
    id: 1,
    name: "Novi Sad",
    lat: 45.267136,
    lng: 19.833549,
    zipCode: "21000 Novi Sad",
    fill: "#212327",
    country: "Serbia",
  },
  {
    id: 2,
    name: "Belgrade",
    lat: 44.787197,
    lng: 20.457273,
    zipCode: "111040 Belgrade",
    fill: "#212327",
    country: "Serbia",
  },
  {
    id: 3,
    name: "Baar",
    lat: 47.19625,
    lng: 8.52954,
    location: "Rathausstrasse 14",
    zipCode: "6340 Baar",
    fill: "#d22128",
    country: "Switzerland",
  },
  {
    id: 4,
    name: "Dubai",
    lat: 25.674941464056516,
    lng: 55.77848989580949,
    location: "T2 9F 1E R. RAKEZ Amenity Center",
    zipCode: "Al Hamra Industrial Area, RAK",
    fill: "#d22128",
    country: "United Arab Emirates",
  },
  {
    id: 5,
    name: "Mississauga",
    lat: 43.5524,
    lng: -79.7553,
    location: "2233 Argentia Road  East Tower, suite 302",
    zipCode: "L5N 2X7, Mississauga, Ontario",
    fill: "#d22128",
    country: "Canada",
  },
  {
    id: 6,
    name: "New York",
    lat: 40.7549,
    lng: -73.984,
    location: "104 West 40th Street, Suites 400 and 500, Office 520",
    zipCode: "10018 New York, NY",
    fill: "#d22128",
    country: "USA",
  },
];

const Smap = (props) => {
  const defaultProps = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627,
    },
    zoom: 11,
  };

  const [isShown, setIsShown] = useState(false);
  const [activeMarker, setActiveMarker] = useState({});

  const renderMarker = () => {
    const { name, location, zipCode, position, country } = activeMarker;
    return (
      <InfoWindow
        position={{
          lat: Number(position.lat),
          lng: Number(position.lng),
        }}
        onCloseClick={() => setIsShown(false)}
      >
        <div className="-mapLocation">
          <div className="-outer"></div>
          <div className="-inner"></div>
          <p className="-title"> {name} </p>
          <p> {location} </p>
          <p> {zipCode} </p>
          <p> {country} </p>
        </div>
      </InfoWindow>
    );
  };

  return (
    <div className="_wr">
      <div className="_w">
        <div
          className="m-location__map--map"
          style={{ height: "80vh", width: "100%" }}
        >
          <GoogleMapReact
            className="-map"
            mapContainerStyle={containerStyle}
            bootstrapURLKeys={{ key: GOOGLE_MAPS_KEY }}
            defaultCenter={center}
            defaultZoom={2}
            options={{ styles: MAP_STYLES }}
          >
            {props.isMarkerShown &&
              markers.map(
                ({ id, lat, lng, fill, name, location, zipCode, country }) => (
                  <Marker
                    key={id}
                    lat={lat}
                    lng={lng}
                    fill={fill}
                    location={location}
                    name={name}
                    zipCode={zipCode}
                    country={country}
                    text="mytext"
                    onClick={() => {
                      setActiveMarker({ lat, lng });
                      setIsShown(true);
                    }}
                    onMouseOver={() => {
                      setActiveMarker({ lat, lng });
                      setIsShown(true);
                    }}
                  ></Marker>
                ),
              )}
            {isShown && renderMarker()}
          </GoogleMapReact>
        </div>
      </div>
    </div>
  );
};
export default Smap;
